import React, { useContext } from 'react';
import { Container, Grid, TAGTypography, useMediaQuery, TAGButton } from '../..';
import { FacilityContext } from '../../contexts';
import { ASPENDENTAL_COLOR, ASPENDENTAL_FONTS } from '../../constants/constant';

var CallToAction = function CallToAction(_ref) {
  var _facilityState$addres, _facilityState$addres2, _facilityState$addres3;

  var buttonLink = _ref.buttonLink,
      buttonText = _ref.buttonText,
      _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === void 0 ? 'Primary Default' : _ref$buttonType,
      title = _ref.title;

  var _useContext = useContext(FacilityContext),
      facilityState = _useContext.state;

  var mobileWidth = useMediaQuery('(max-width:600px)');
  return React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '1160px',
      minHeight: '260px',
      backgroundColor: !mobileWidth ? 'neutrals.neutral' : 'neutrals.white',
      '> p': {
        marginTop: 0,
        marginBottom: '10px',
        fontSize: '18px',
        fontWeight: '350',
        lineHeight: '28px',
        color: ASPENDENTAL_COLOR.text.secondary,
        fontFamily: ASPENDENTAL_FONTS.breadcrumb.fontFamily
      }
    }
  }, (facilityState === null || facilityState === void 0 ? void 0 : (_facilityState$addres = facilityState.address) === null || _facilityState$addres === void 0 ? void 0 : _facilityState$addres.city) && React.createElement("p", null, "".concat(facilityState === null || facilityState === void 0 ? void 0 : (_facilityState$addres2 = facilityState.address) === null || _facilityState$addres2 === void 0 ? void 0 : _facilityState$addres2.city, ", ").concat(facilityState === null || facilityState === void 0 ? void 0 : (_facilityState$addres3 = facilityState.address) === null || _facilityState$addres3 === void 0 ? void 0 : _facilityState$addres3.state)), React.createElement(TAGTypography, {
    variant: "h2",
    sx: {
      marginBottom: '30px',
      textAlign: 'center'
    }
  }, title), React.createElement(TAGButton, {
    buttonVariant: buttonType,
    defaultButtonVariant: "Primary Default",
    href: buttonLink
  }, buttonText)));
};

export default CallToAction;